import React, { useRef, useState } from "react";
import { Link } from "react-router-dom";
import { useAuth } from "@/context/AuthProvider";
import { FEATURE_GROUPS, RESOURCE_LINKS } from "@/lib/marketingNav";
import { useClickOutside } from "@/lib/useClickOutside";

export default function MarketingHeader() {
  const { user } = useAuth();
  const [open, setOpen] = useState(null); // "features" | "resources" | null
  const navRef = useRef(null);

  const toggle = (key) => setOpen((v) => (v === key ? null : key));
  const close = () => setOpen(null);
  useClickOutside(navRef, close, open !== null);

  return (
    <header className="mkt-nav" data-testid="marketing-nav">
      <Link to="/" className="mkt-logo" onClick={close}>
        <span className="mkt-hex">⬡</span> GovCo<span className="mkt-logo-ai">.AI</span>
      </Link>

      <nav className="mkt-links" ref={navRef}>
        <div className="mkt-menu">
          <button
            className={`mkt-trigger ${open === "features" ? "active" : ""}`}
            onClick={() => toggle("features")}
            data-testid="mkt-features-trigger"
          >
            Features <span className="mkt-caret">▾</span>
          </button>
          {open === "features" && (
            <div className="mkt-panel" data-testid="mkt-features-panel">
              {FEATURE_GROUPS.map((group) => (
                <Link key={group.slug} to={`/features/${group.slug}`} className="mkt-item" onClick={close}>
                  {group.title}
                </Link>
              ))}
            </div>
          )}
        </div>

        <div className="mkt-menu">
          <button
            className={`mkt-trigger ${open === "resources" ? "active" : ""}`}
            onClick={() => toggle("resources")}
            data-testid="mkt-resources-trigger"
          >
            Resources <span className="mkt-caret">▾</span>
          </button>
          {open === "resources" && (
            <div className="mkt-panel" data-testid="mkt-resources-panel">
              {RESOURCE_LINKS.map((item) => (
                <Link key={item.href} to={item.href} className="mkt-item" onClick={close}>
                  {item.label}
                </Link>
              ))}
            </div>
          )}
        </div>

        <Link to="/pricing" className="mkt-plain-link" data-testid="mkt-pricing-link" onClick={close}>
          Pricing
        </Link>
      </nav>

      {user ? (
        <Link className="mkt-cta" to="/dashboard" data-testid="mkt-dashboard">Go to dashboard →</Link>
      ) : (
        <Link className="mkt-cta" to="/login" data-testid="mkt-signin">Sign in →</Link>
      )}
    </header>
  );
}
